import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {SessionStorage} from 'ngx-webstorage';
import {User} from "../../../shared/user/user";
import {Pair} from "../../../shared/util/pair";
import {TranslationService} from "../../shared";

@Component({
  standalone: false,
  selector: 'app-odm-modal-name',
  templateUrl: './odm-modal-name.component.html',
  styleUrls: ['./odm-modal-name.component.scss']
})
export class OdmModalNameComponent implements OnInit {


  @ViewChild('childModalValidate') changeNameModal: OdmModalNameComponent;

  @SessionStorage()
  public user: User;

  @Input()
  categoryNameKey: string;

  @Input()
  isAddedModal = false;

  @Output() onConfirmButton = new EventEmitter();


  translationsByLanguages: Pair<string, string>[];
  isLoading = false;

  constructor(private translationService: TranslationService) { }

  ngOnInit(): void {
    this.isLoading = true;
    this.translationsByLanguages = [];
    if (!this.isAddedModal){
      this.translationService.getLocalesOfCountryOfKey(this.categoryNameKey).subscribe( localeKeys => {
        localeKeys.forEach(value => {
          let pair;
          if (value.translations.length === 0) {
            pair = new Pair<string, string>(value.language, '');
          } else {
            pair = new Pair<string, string>(value.language, value.translations[0].translation);
          }
          this.translationsByLanguages.push(pair);
        });
        this.isLoading = false;
      },
        ()=> this.isLoading = false);
    } else {
      this.translationService.getAllLanguagesByCountry(this.user.partnerCountry)
        .subscribe(langs =>
        langs.forEach(lang => this.translationsByLanguages.push(new Pair<string, string>(lang, ""))),
          ()=> this.isLoading = false);
        this.isLoading = false;
    }
  }

  show() {
    // clear the names from the previous add, like the accessories category name modal
    if (this.isAddedModal) {
      this.translationsByLanguages = this.translationsByLanguages.map(
        pair => new Pair<string, string>(pair.getKey(), '')
      );
    }
    this.changeNameModal.show();
  }

  tranlationChange(language: string, event: any) {
    let newTranslationsByLanguages: Pair<string, string>[] = [];
    this.translationsByLanguages.forEach(value => {
      if (value.getKey() === language) {
        newTranslationsByLanguages.push(new Pair<string, string>(language, event.target.value));
      } else {
        newTranslationsByLanguages.push(value);
      }
    });
    this.translationsByLanguages = newTranslationsByLanguages;
  }

  // function for the ngfor, so the input doesn't lose focus while typing
  trackByFn(index: number): number {
    return index;
  }

  // every language must have a name that is not empty or only spaces
  isValidForm(): boolean {
    if (!this.translationsByLanguages || this.translationsByLanguages.length === 0) {
      return false;
    }
    for (const translation of this.translationsByLanguages) {
      const name = translation.getValue();
      if (!name || name.trim() === '') {
        return false;
      }
    }
    return true;
  }

  // send the names without leading or trailing spaces
  sendConfirmation() {
    const trimmedTranslations = this.translationsByLanguages.map(translation =>
      new Pair<string, string>(translation.getKey(), translation.getValue()?.trim())
    );
    this.onConfirmButton.emit(trimmedTranslations);
  }

  hide() {
    this.changeNameModal.hide();
  }
}
